import React from "react";
import {
  FaCalendarAlt,
  FaClipboardList,
  FaExclamationTriangle,
  FaTimes,
} from "react-icons/fa";

const ExpiryAlertModal = ({
  isOpen,
  onClose,
  onHideModal,
  expiringDrugs,
  expiredDrugs,
  onViewDetails,
}) => {
  if (!isOpen) return null;

  const totalItems = expiringDrugs + expiredDrugs;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full animate-slideUp">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-600 to-orange-600 p-6 rounded-t-xl relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors"
          >
            <FaTimes size={20} />
          </button>
          <div className="flex items-center gap-3 text-white">
            <div className="bg-white bg-opacity-20 p-3 rounded-lg">
              <FaExclamationTriangle size={24} />
            </div>
            <div>
              <h2 className="text-xl font-bold">Drug Expiry Alert</h2>
              <p className="text-sm text-red-100">
                Immediate attention required
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="mb-6">
            <p className="text-gray-700 mb-4">
              You have drugs that require immediate attention:
            </p>

            <div className="space-y-3">
              {expiredDrugs > 0 && (
                <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <FaExclamationTriangle className="text-red-600" />
                      <div>
                        <p className="font-semibold text-red-900">
                          Already Expired
                        </p>
                        <p className="text-sm text-red-700">
                          Remove from inventory immediately
                        </p>
                      </div>
                    </div>
                    <span className="bg-red-600 text-white px-3 py-1 rounded-full text-lg font-bold">
                      {expiredDrugs}
                    </span>
                  </div>
                </div>
              )}

              {expiringDrugs > 0 && (
                <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <FaCalendarAlt className="text-orange-600" />
                      <div>
                        <p className="font-semibold text-orange-900">
                          Expiring Soon
                        </p>
                        <p className="text-sm text-orange-700">
                          Within 90 days
                        </p>
                      </div>
                    </div>
                    <span className="bg-orange-600 text-white px-3 py-1 rounded-full text-lg font-bold">
                      {expiringDrugs}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-gray-600 flex items-start gap-2">
              <FaExclamationTriangle className="text-yellow-600 mt-0.5 flex-shrink-0" />
              <span>
                Expired drugs must be removed from inventory immediately.
                Expiring drugs should be prioritized for dispensing or marked
                for return.
              </span>
            </p>
          </div>

          {/* Actions */}
          <div className="space-y-3">
            <button
              onClick={onViewDetails}
              className="w-full bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
            >
              <FaClipboardList />
              View All Expiring Drugs
            </button>

            {/* <button
                onClick={onHideModal}
                className="w-full border-2 border-gray-300 hover:bg-gray-50 text-gray-700 px-6 py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
              >
                <FaTimes />
                Don't Show Again Today
              </button> */}
          </div>
        </div>
      </div>

      <style>{`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-fadeIn {
            animation: fadeIn 0.2s ease-out;
          }
          .animate-slideUp {
            animation: slideUp 0.3s ease-out;
          }
        `}</style>
    </div>
  );
};

export default ExpiryAlertModal;
